import React, { useEffect } from 'react'
import $ from 'jquery';
import error from '../../images/404/error-404.png';
import { Link } from 'react-router-dom';
import './page404.scss';

function PageNotFoundError() {

   useEffect(() => {
      $('footer').hide();
      return () => {
         $('footer').show()
      }
   });

   return (
      <div className="p404 d-flex align-items-center justify-content-center">
         <div className="p404-center text-center d-flex justify-content-around">
            <div className="img404">
               <img src={error} alt="Error 404"></img>
            </div>
            <main className="txt404">
               <h1>404</h1>
               <h2>Sorry, page not found</h2>
               <p>Please, take me back to...</p>
               <div className="d-flex justify-content-around">
                  <Link to="/"><button className="btn btn-light">Home</button></Link>
                  <Link to="/products"><button className="btn btn-light">Products</button></Link>
                  <Link to="/cart"><button className="btn btn-light">Cart</button></Link>
               </div>
            </main>
         </div>
      </div>
   )
}

export default PageNotFoundError;
